var map = {
	"./icon_menu_fkyj.png": 7585,
	"./icon_menu_fkyj_active.png": 8988,
	"./icon_menu_sjkgl.png": 1998,
	"./icon_menu_sjkgl_active.png": 5781,
	"./icon_menu_sy.png": 6373,
	"./icon_menu_sy_active.png": 7368,
	"./icon_menu_yhgl.png": 3719,
	"./icon_menu_yhgl_active.png": 3797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5950;